import React, { memo } from 'react';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { default as CheckboxBringg } from '../../checkbox/checkbox';

export interface CheckboxProps {
	label: string;
	checked: boolean;
	onChange: (event: CheckboxChangeEvent) => void;
}

const Checkbox = ({ label, checked, onChange }: CheckboxProps) => (
	<CheckboxBringg checked={checked} onChange={onChange}>
		{label}
	</CheckboxBringg>
);

export default memo(Checkbox);
